import React, { useState, useEffect } from "react";
import { graphql } from "gatsby";
import axios from "axios";
import * as Scroll from "react-scroll";
import Layout from "../containers/layout";
import "@reach/combobox/styles.css";
import { mapEdgesToNodes } from "../lib/helpers";
import BlockText from "../components/block-text";
import Container from "../components/container";
import GraphQLErrorList from "../components/graphql-error-list";
import SEO from "../components/seo";
import Hero from "../components/Hero";

import UnsureCard from "../components/Unsure/UnsureCard";
import wait from "waait";
import MapComponent from "../components/Clinics/Map";
import Faq from "../components/Faq/Faq";
import Contact from "../components/Contact/Contact";
import {
  NotificationsContainer,
  notificationService,
} from "../services/Notifications/Notifications";
import useModal from "../components/Modal/useModal";
import SendingFormDataModal from "../components/SendingFormDataModal/SendingFormDataModal";
import { Partners } from "../components/Partners/Partners";
import TelefonInfoModal from "../components/MapInfoModals/TelefonInfoModal";
import SendingFormDataInfoModal from "../components/MapInfoModals/SendingFormDataInfoModal";
import { Spinner } from "../components/Spinner/Spinner";

export const query = graphql`
  query IndexPageQuery {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
      description
      keywords
      mainImage {
        alt
        caption
        asset {
          gatsbyImageData(fit: FILLMAX, placeholder: BLURRED)
          _id
        }
        crop {
          _key
          _type
          top
          bottom
          left
          right
        }
        hotspot {
          _key
          _type
          x
          y
          height
          width
        }
      }
      # Attention Button Left
      heroAttentionLeftButton {
        _key
        _type
        callToActionLeftTitle
        callToActionLeftUrl
        hasHeroAttentionLeftButton
      }
      # Attention Button Right
      heroAttentionRightButton {
        _key
        _type
        callToActionRightTitle
        callToActionRightUrl
        hasHeroAttentionRightButton
      }
      _rawHeroAttentionText
      heroAttentionTitle
      clinicsFormReceiverEmail
      contactFormReceiverEmail
      # ratgeberFormErrorMessage
      # ratgeberFormSuccessMessage
      # contactFormErrorMessage
      # contactFormSuccessMessage
    }

    infoMessages: sanityInfoMessages {
      ratgeberFormErrorMessage
      ratgeberFormSuccessMessage
      contactFormErrorMessage
      contactFormSuccessMessage
    }

    clinics: allSanityClinics {
      edges {
        node {
          _id
          id
          name
          tel
          website
          email
          address
          coordinates {
            latitude
            longitude
          }
          openingHoursFields {
            _key
            _type
            # Opening Hours
            mondayOpeningHours
            tuesdayOpeningHours
            wednesdayOpeningHours
            thursdayOpeningHours
            fridayOpeningHours
            saturdayOpeningHours
            sundayOpeningHours
            # Emergency Hours
            mondayEmergencyHours
            tuesdayEmergencyHours
            wednesdayEmergencyHours
            thursdayEmergencyHours
            fridayEmergencyHours
            saturdayEmergencyHours
            sundayEmergencyHours
          }
          type
          emailInfo
          emergencyTelInfo
        }
      }
    }

    menu: sanityMenu(_id: { regex: "/(drafts.|)menu/" }) {
      id
      menuitems {
        _key
        _type
        name
        url
        menutype
      }
      menuName
    }

    map: file(name: { eq: "googlemaps" }) {
      id
      publicURL
    }

    testimonials: sanityTestimonials(_id: { regex: "/(drafts.|)testimonials/" }) {
      title
      description
      testimonialhero {
        asset {
          _id
        }
        crop {
          _key
          _type
          top
          bottom
          left
          right
        }
        hotspot {
          _key
          _type
          x
          y
          height
          width
        }
      }
    }

    guideFormGeneral: sanityGuideFormGeneral {
      infoLabel1
      infoLabel2
      infoLabel3
      infoLabel4
      infoTitle
      title
    }

    faqs: sanityFaq {
      id
      _rawFaqItems
      title
    }

    sendingFormData: sanitySendingFormData {
      id
      titleStep1
      titleStep2
      _rawInfoText
    }

    partners: sanityPartners {
      title
      infotext
      partnersList {
        _key
        _type
        url
        logo {
          hotspot {
            _key
            _type
            x
            y
            height
            width
          }
          crop {
            _key
            _type
            top
            bottom
            left
            right
          }
          asset {
            _id
            _key
          }
          caption
          alt
        }
      }
    }
  }
`;

const IndexPage = (props) => {
  const { data, errors } = props;

  // Rehydration fix
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 100);
  }, []);

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    );
  }

  const site = (data || {}).site;
  const infoMessages = (data || {}).infoMessages;
  const menu = (data || {}).menu;
  const guideFormGeneral = (data || {}).guideFormGeneral;
  const faqs = (data || {}).faqs;
  const clinics = (data || {}).clinics ? mapEdgesToNodes(data.clinics) : [];
  const sendingFormData = (data || {}).sendingFormData;
  const partners = (data || {}).partners;

  if (!site) {
    throw new Error(
      'Missing "Site settings". Open the studio at http://localhost:3333 and add some content to "Site settings" and restart the development server.'
    );
  }

  const [refferer, setReferrer] = useState({
    refferalId: null,
    clinicId: null,
  });

  let urlParams = new URLSearchParams(props.location.search);
  const _id = urlParams.get("utm_referrer");
  const eventData = {
    _id: _id,
  };

  const incrementReferrer = (_id) => {
    axios
      .post("/.netlify/functions/incrementReferrals", JSON.stringify(eventData))
      .then((response) => {
        console.log("successfully incremented the referralCount of ", _id);
      })
      .catch((error) => {
        console.log("something went wrong communicating with the lambda=incrementReferrals", error);
      });
  };

  useEffect(() => {
    if (_id) {
      incrementReferrer(_id);
      let referralDot = _id.indexOf(".");
      let clinicId = _id.slice(referralDot + 1);

      setReferrer({ ...refferer, refferalId: _id, clinicId: clinicId });
    }
  }, []);

  var Element = Scroll.Element;

  var scroller = Scroll.scroller;
  const [unsicher, setUnsicher] = React.useState(false);

  const handleHeroButton = (element) => {
    if (!unsicher) {
      scroller.scrollTo(element, {
        duration: 1000,
        smooth: true,
        offset: 50, // Scrolls to element + 50 pixels down the page
      });
    }
  };

  const scrollToIdElement = async (element) => {
    scroller.scrollTo(element, {
      duration: 1200,
      delay: 450,
      smooth: true,
    });
    await wait(2000);
  };

  // handles data and user info for sending form results to clinic
  const [modalToggled, toggleModal] = useModal();

  const [formData, setFormData] = useState({
    formFilled: false,
    selectedClinic: {},
    animalinfo: {
      animalname: "",
      age: "",
      species: "",
      sex: "",
      weight: null,
      castrated: false,
      preconditions: {
        heart: false,
        kidney: false,
        liver: false,
        epilepsia: false,
        cancer: false,
        other: "",
      },
      lastHeat: new Date(),
      pregnant: false,
      givingBirth: false,
      free: false,
      abroadLocation: "",
      wormcure: new Date(),
      vaccine: new Date(),
      rawFood: "",
    },
    generalcondition: "",
    vitalvalues: {
      bodyTemp: 0,
      glandColor: "nicht bestimmt",
      breathFreq: 0,
    },
    drinkandeat: {
      drinking: {
        behavior: 1,
        since: 0,
      },
      eating: {
        behavior: 1,
        since: 0,
      },
    },
    excretions: {
      urine: {
        behavior: 1,
        since: 0,
        bloody: false,
      },
      droppings: {
        behavior: 1,
        since: 0,
        bloody: false,
        black: false,
      },
      vomiting: {
        behavior: 1,
        since: 0,
        foamy: false,
        bile: false,
        bloody: false,
      },
    },
    specialcases: {
      birth: false,
      cramp: false,
      accident: false,
      foreignObject: false,
      homeAnimals: false,
      intoxications: false,
    },
  });

  /*
    Handles Information Modal for Sending Data to Clinic
  */
  const [SendingFormDataInfoModalToggled, toggleSendingFormDataInfoModal] = useModal();

  const handleFillOutForm = async () => {
    await toggleSendingFormDataInfoModal();
    scrollToIdElement("ratgeber");
  };

  const handleSendingData = (selected) => {
    if (!formData.formFilled) {
      toggleSendingFormDataInfoModal();
      return;
    }
    setFormData({ ...formData, selectedClinic: selected });
    toggleModal();
  };

  const handleSendingDataSuccess = () => {
    toggleModal();
    notificationService.success(infoMessages.ratgeberFormSuccessMessage);
  };

  const handleSendingDataError = () => {
    notificationService.error(infoMessages.ratgeberErrorMessage);
  };

  /*
    Handles Information Modal for Telefon on Map Component
  */
  const [TelefonInfoModalToggled, toggleTelefonInfoModal] = useModal();
  const [selectedClinic, setSelectedClinic] = useState({});

  const handleTelefonInfoModal = async (selected) => {
    await setSelectedClinic(selected);
    toggleTelefonInfoModal();
  };

  const handleSaveFormData = (
    animalinfoData,
    vitalvaluesData,
    drinkandeatData,
    excretionsData,
    generalconditionData,
    specialcasesData
  ) => {
    setFormData({
      ...formData,
      formFilled: true,
      animalinfo: animalinfoData,
      vitalvalues: vitalvaluesData,
      drinkandeat: drinkandeatData,
      excretions: excretionsData,
      generalcondition: generalconditionData,
      specialcases: specialcasesData,
    });
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 100,
            display: "grid",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner />
        </div>
      )}
      {!loading && (
        <Layout menus={menu} showNav={true}>
          <SEO title={site.title} description={site.description} keywords={site.keywords} />
          <Hero mainImage={site.mainImage}>
            <div className="heroWrapper">
              <h1 className="h1 inline-grid--hero">{site.heroAttentionTitle}</h1>
              <div className="heroWrapper__attentionText">
                {site._rawHeroAttentionText && <BlockText blocks={site._rawHeroAttentionText} />}
              </div>

              <div className="heroWrapper__buttonFlex">
                {site.heroAttentionLeftButton.hasHeroAttentionLeftButton && (
                  <button
                    className="button heroWrapper__buttonLeft"
                    onClick={() =>
                      handleHeroButton(`${site.heroAttentionLeftButton.callToActionLeftUrl}`)
                    }
                  >
                    {site.heroAttentionLeftButton.callToActionLeftTitle}
                  </button>
                )}
                {site.heroAttentionRightButton.hasHeroAttentionRightButton && (
                  <button
                    className="button heroWrapper__buttonRight"
                    onClick={() =>
                      handleHeroButton(`${site.heroAttentionRightButton.callToActionRightUrl}`)
                    }
                  >
                    {site.heroAttentionRightButton.callToActionRightTitle}
                  </button>
                )}
              </div>
            </div>
          </Hero>
          <Container>
            <section className="chooser" id="ratgeber">
              <Element name="Unsicher">
                <UnsureCard
                  unsicher={true}
                  setUnsicher={setUnsicher}
                  scrollToIdElement={scrollToIdElement}
                  handleSaveFormData={handleSaveFormData}
                  guideFormGeneralData={guideFormGeneral}
                />
              </Element>
            </section>

            <section className="info">
              <div className="card-grid infocards">
                <MapComponent
                  clinics={clinics}
                  handleSendingData={handleSendingData}
                  handleTelefonInfoModal={handleTelefonInfoModal}
                  formData={formData}
                />

                <div className="card info--telCard" id="telefonisch">
                  <Partners partners={partners} />
                </div>
              </div>
            </section>

            <Faq faqs={faqs} />

            <Contact
              receiverEmail={site.contactFormReceiverEmail}
              successMessage={infoMessages.contactFormSuccessMessage}
              errorMessage={infoMessages.contactFormErrorMessage}
            />
          </Container>

          <SendingFormDataModal
            modalToggled={modalToggled}
            toggleModal={toggleModal}
            submitButtonText="Senden"
            cancelButtonText="Abbrechen"
            formData={formData}
            handleSendingDataSuccess={handleSendingDataSuccess}
            handleSendingDataError={handleSendingDataError}
            sendingFormData={sendingFormData}
            reffererId={_id}
            clinics={clinics}
            location={props.location}
          />

          <NotificationsContainer />

          <TelefonInfoModal
            modalToggled={TelefonInfoModalToggled}
            toggleModal={toggleTelefonInfoModal}
            selectedClinic={selectedClinic}
          />

          <SendingFormDataInfoModal
            modalToggled={SendingFormDataInfoModalToggled}
            toggleModal={toggleSendingFormDataInfoModal}
            handleSendingData={handleSendingData}
            handleFillOutForm={handleFillOutForm}
          />
        </Layout>
      )}
    </>
  );
};

export default IndexPage;
